import Vue from 'vue'
import { API_URL } from '../../api'
import ProjectValuationsFilter from '../../filters/ProjectValuationsFilter';
const state = {
    projectValuationCreate: {
        createdProjectValuation: null,
        creatingProjectValuation: false,
        createProjectValuationStatus: null
    },
    projectValuationUpdate: {
        updatedProjectValuation: null,
        updatingProjectValuation: false,
        updateProjectValuationStatus: null
    },
    projectValuationDelete: {
        deletingProjectValuation: false,
        deleteProjectValuationStatus: null
    },
    projectValuationSearch: {
        projectValuationsCount: null,
        projectValuations: [],
        searchingProjectValuations: false,
        searchProjectValuationStatus: null
    },
}
const mutations = {
    ['SET_PROJECT_VALUATION_CREATE'](state, change) {
        state.projectValuationCreate = { ...state.projectValuationCreate, ...change };
    },
    ['SET_PROJECT_VALUATION_UPDATE'](state, change) {
        state.projectValuationUpdate = { ...state.projectValuationUpdate, ...change };
    },
    ['SET_PROJECT_VALUATION_DELETE'](state, change) {
        state.projectValuationDelete = { ...state.projectValuationDelete, ...change };
    },
    ['SET_PROJECT_VALUATION_SEARCH'](state, change) {
        state.projectValuationSearch = { ...state.projectValuationSearch, ...change };
    }
}
const actions = {
    createProjectValuation: ({ commit }, payload) => {
        commit('SET_PROJECT_VALUATION_CREATE', { createProjectValuationStatus: null, createdProjectValuation: null, creatingProjectValuation: true })
        return Vue.http.post(API_URL + '/projects/valuations/create', payload).then(response => {
            commit('SET_PROJECT_VALUATION_CREATE', { createProjectValuationStatus: 'success', createdProjectValuation: response.body.results.projectValuation });
        }).catch(response => {
            commit('SET_PROJECT_VALUATION_CREATE', { createProjectValuationStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_VALUATION_CREATE', { creatingProjectValuation: false });
        });
    },
    updateProjectValuation: ({ commit }, payload) => {
        commit('SET_PROJECT_VALUATION_UPDATE', { updateProjectValuationStatus: null, updatedProjectValuation: null, updatingProjectValuation: true })
        return Vue.http.post(API_URL + '/projects/valuations/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PROJECT_VALUATION_UPDATE', { updateProjectValuationStatus: 'success', updatedProjectValuation: response.body.results.projectValuation });
            })
            .catch(response => {
                commit('SET_PROJECT_VALUATION_UPDATE', { updateProjectValuationStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PROJECT_VALUATION_UPDATE', { updatingProjectValuation: false });
            })
    },
    deleteProjectValuation: ({ commit }, id) => {
        commit('SET_PROJECT_VALUATION_DELETE', { deleteProjectValuationStatus: null, deletedProjectValuation: null, deletingProjectValuation: true })
        return Vue.http.delete(API_URL + '/projects/valuations/delete/' + id).then(response => {
            commit('SET_PROJECT_VALUATION_DELETE', { deleteProjectValuationStatus: 'success' });
        }).catch(response => {
            commit('SET_PROJECT_VALUATION_DELETE', { deleteProjectValuationStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_VALUATION_DELETE', { deletingProjectValuation: false });
        })
    },
    searchProjectValuations: ({ commit }, payload = { filter: ProjectValuationsFilter(), resultMode: 'default' }) => {
        commit('SET_PROJECT_VALUATION_SEARCH', { searchProjectValuationStatus: null, searchProjectValuation: null, searchingProjectValuations: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/projects/valuations' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_PROJECT_VALUATION_SEARCH', { searchProjectValuationStatus: 'success', projectValuationsCount: response.body.results.projectValuations });

            } else if (payload.resultMode == 2) {
                commit('SET_PROJECT_VALUATION_SEARCH', { searchProjectValuationStatus: 'success', projectValuationsPaginated: response.body.results.projectValuations });

            } else {
                commit('SET_PROJECT_VALUATION_SEARCH', { searchProjectValuationStatus: 'success', projectValuations: response.body.results.projectValuations });
            }
        }).catch(response => {
            commit('SET_PROJECT_VALUATION_SEARCH', { searchProjectValuationStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_VALUATION_SEARCH', { searchingProjectValuations: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/projectValuationStore.js